<template>
  <div v-if="elementInfo" class="viewer-element-section"
       :class="{ 'lock': elementInfo.lock }"
       :style="{
      top: elementInfo.top + 'px',
      left: elementInfo.left + 'px'
    }"
  >
    <div
        class="rotate-wrapper"
        :style="{ transform: `rotate(${elementInfo.rotate}deg)` }"
    >
      <div
          class="element-content"
          :style="{
          backgroundColor: elementInfo.fill,
          padding: '4px'
        }">
        <SlideLayoutViewerElement
            v-if="slideLayoutElement"
            :key="slideLayoutElement.id"
            :elementInfo="slideLayoutElement"
            :elementIndex="2"
            :isMultiSelect="false"
            :selectElement="selectElement"
            :openLinkDialog="null"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {PropType, computed, watch} from 'vue'
import { PPTSectionElement } from '@/types/slides'
import SlideLayoutViewerElement from '@/views/components/element/SlideLayoutViewerElement/index.vue'
import {useMainStore, useSlidesStore} from "@/store";
const slidesStore = useSlidesStore()

const props = defineProps({
  elementInfo: {
    type: Object as PropType<PPTSectionElement>,
    required: true,
  }
})

const mainStore = useMainStore()
const selectElement = () => {
  mainStore.setActiveElementIdList([props.elementInfo.id])
}

const slideLayoutElement = computed(() => {
  return slidesStore.getElementsByTypeAllSlides('slidelayout').find(layout => layout.id === props.elementInfo.slideLayoutId)
})
</script>

<style lang="scss" scoped>

.rotate-wrapper {
  width: 100%;
  height: 100%;
}
.element-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
